import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";

const EnterpriseServiceManagement = () => {
    const intl = useIntl();
    return (
        <TabsContent
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue",
                        defaultMessage: "Deliver value fast"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue.bodytext",
                        defaultMessage:
                            "Replace costly legacy tools and deploy faster with a powerful, easy-to-use platform that has transparent pricing."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps",
                        defaultMessage: "Accelerate dev and ops"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps.bodyText",
                        defaultMessage:
                            "Instead of siloed tools, increase visibility and the flow of work by connecting Development and IT Operations teams on a single platform."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll",
                        defaultMessage: "Empower service for all"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll.bodyText",
                        defaultMessage:
                            "Help every team take ownership of their service experience and scale practices - without costly add-ons or confusing deployments."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.learnMore",
                    defaultMessage: "Learn about service management"
                }),
                link: useLocalizedHref("/solutions/itsm"),
                linkLabel: "Learn about service management",
                productKey: "enterprise"
            }}
            pictureProps={{
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/x2s3unwoyy1xp3222df5pu0j23fx7lki.webp",
                    alt: "",
                    width: 1544,
                    height: 1092
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "EnterpriseLandingPage.tab.serviceManagement.resources",
                defaultMessage: "Service management resources"
            })}
            cardsContent={[
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport",
                        defaultMessage: "Forrester report"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.headerText",
                        defaultMessage:
                            "Atlassian is a Leader in Enterprise Service Management, Q4 2023"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.linkText",
                            defaultMessage: "Read report"
                        }),
                        href: useLocalizedHref(
                            "/forrester/wave-enterprise-service-management"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Read report"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterWave-3356930698.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar",
                        defaultMessage: "ROI resources"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.headerText",
                        defaultMessage:
                            "The Total Economic Impact of Jira Service Management"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.linkText",
                            defaultMessage: "Explore resources"
                        }),
                        href: useLocalizedHref(
                            "/jira/service-management/total-economic-impact-hub"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Explore resources"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/totEconomicImpact-1137923345.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide",
                        defaultMessage: "Guide"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.headerText",
                        defaultMessage: "ITSM for high-velocity teams"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.linkText",
                            defaultMessage: "Download guide"
                        }),
                        href: "https://wac-cdn.atlassian.com/it/dam/jcr:4ec50253-90f1-4d6c-98e2-2ff994cf94db/Jira-Service-Management-Overview-Datasheet.pdf?cdnVersion=1275#:~:text=Jira%20Service%20Management%20offers%20business,approach%20of%20legacy%20ITSM%20solutions.&text=Empower%20all%20teams%20across%20IT,business%20with%20intuitive%2C%20flexible%20workflows.&text=Make%20work%20visible%20through%20the%20open%20and%20collaborative%20Jira%20platform.",
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Download guide"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/itServiceMngmt-1552092334.webp",
                            alt: ""
                        }
                    }
                }
            ]}
        />
    );
};

export { EnterpriseServiceManagement };
